import React from 'react';
import Icon from '../../../components/AppIcon';

const StatsOverview = () => {
  const stats = [
    {
      icon: "Building2",
      value: "150+",
      label: "Successful Transformations",
      description: "Organizations achieved AI independence",
      color: "text-blue-600"
    },
    {
      icon: "DollarSign",
      value: "$2.4B",
      label: "Total Cost Savings",
      description: "Cumulative savings across all clients",
      color: "text-green-600"
    },
    {
      icon: "Clock",
      value: "8.5 months",
      label: "Average Timeline",
      description: "From assessment to full independence",
      color: "text-purple-600"
    },
    {
      icon: "TrendingUp",
      value: "340%",
      label: "Average ROI",
      description: "Return on investment within 24 months",
      color: "text-orange-600"
    },
    {
      icon: "Shield",
      value: "100%",
      label: "Vendor Independence",
      description: "Complete freedom from proprietary lock-in",
      color: "text-brand-primary"
    },
    {
      icon: "Zap",
      value: "65%",
      label: "Performance Improvement",
      description: "Average increase in AI model performance",
      color: "text-yellow-600"
    }
  ];

  return (
    <div className="bg-white rounded-xl shadow-executive border border-gray-200 p-8">
      <div className="text-center mb-8">
        <h2 className="text-3xl font-bold text-text-primary mb-4">
          Transformation Impact
        </h2>
        <p className="text-lg text-text-secondary max-w-3xl mx-auto">
          Our proven methodology has delivered measurable results across industries, 
          helping organizations break free from vendor dependency and achieve true AI autonomy.
        </p>
      </div>
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
        {stats?.map((stat, index) => (
          <div key={index} className="text-center group hover:bg-gray-50 p-6 rounded-xl transition-colors duration-200">
            <div className={`w-16 h-16 ${stat?.color?.replace('text-', 'bg-')}/10 rounded-xl flex items-center justify-center mx-auto mb-4 group-hover:scale-110 transition-transform duration-200`}>
              <Icon name={stat?.icon} size={32} className={stat?.color} />
            </div>
            <div className="text-4xl font-bold text-text-primary mb-2">
              {stat?.value}
            </div>
            <div className="text-lg font-semibold text-text-primary mb-2">
              {stat?.label}
            </div>
            <div className="text-sm text-text-secondary">
              {stat?.description}
            </div>
          </div>
        ))}
      </div>
      {/* Additional Metrics */}
      <div className="mt-12 pt-8 border-t border-gray-200">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8 text-center">
          <div>
            <div className="text-2xl font-bold text-brand-primary mb-1">12</div>
            <div className="text-sm text-text-secondary">Industries Served</div>
          </div>
          <div>
            <div className="text-2xl font-bold text-brand-primary mb-1">98%</div>
            <div className="text-sm text-text-secondary">Client Satisfaction</div>
          </div>
          <div>
            <div className="text-2xl font-bold text-brand-primary mb-1">24/7</div>
            <div className="text-sm text-text-secondary">Support Coverage</div>
          </div>
          <div>
            <div className="text-2xl font-bold text-brand-primary mb-1">Zero</div>
            <div className="text-sm text-text-secondary">Failed Migrations</div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default StatsOverview;